module.exports = __webpack_public_path__ + "d31638c0429491627649e1537f03d80d.fbx";